export function diaBlock(llista, data, def) {
    return llista.find((item) => item.data === data) ? Number(llista.find((item) => item.data === data)?.block_free) : !def;
}

export function setMaxPx(max, reserves, data) {
    return reserves ? max - reserves?.filter((f) => f?.data === data).reduce((sum, num) => sum + Number(num?.total), 0) : max;
}
